import React, { useState } from 'react';
import { withRouter, Redirect, useHistory } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import {
  combineValidators,
  composeValidators,
  isRequired,
  createValidator,
} from 'revalidate';
import { reduxForm, Field, reset } from 'redux-form';
import { forgetPasswordAuth } from './redux/authApi';
import LoginTextInput from '../common/form/LoginTextInput';
import BackToLogin from './part/BackToLogin';
import BodyAuth from './part/BodyAuth';
import { useWindowSize } from '../common/helpers/sizeHelper';

function mapState(state) {
  return {
    auth: state.auth,
    loading: state.async.loading,
  };
}

const actions = {
  forgetPasswordAuth,
};

const isValidEmail = createValidator(
  (message) => (value) => {
    if (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      return message;
    }
  },
  'Invalid email address'
);

const validate = combineValidators({
  email: composeValidators(
    isRequired({ message: 'Email harus diisi' }),
    isValidEmail
  )(),
});

function ForgetPassword({
  forgetPasswordAuth,
  handleSubmit,
  auth,
  error,
  loading,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const basedUrl = window.location.origin;

  const [status, setNotif] = useState(false);
  const [message, setMessage] = useState('');

  const handleForgetPassword = async (authData) => {
    let newData = { ...authData, url: basedUrl };
    const res = await forgetPasswordAuth(history, newData);
    console.log(res.status, res.message, res.user);
    
    if (res.status === 'success') {
      setNotif(true);
      setMessage(res.message);
      dispatch(reset('formForgetPassword'));
    } else if (res.status === 'not found') {
      setNotif(false);
      setMessage(res.message); // 'Email is not registered!'
    } else {
      setNotif(false);
      setMessage('Something went wrong!');
    }
  };

  let windowSize = useWindowSize();

  const handleBackToLogin = () => {
    return history.push('/');
  };

  if (auth && auth.isAuth && auth.registerParents)
    return <Redirect to='/register-2' />;
  if (auth && auth.isAuth && !auth.registerParents)
    return <Redirect to='/dashboard' />;

  return (
    <BodyAuth
      title={''}
      width={
        windowSize[0] < 450 ? (windowSize[0] > 365 ? 365 : windowSize[0]) : 450
      }
    >
      {status && message === 'Email is send' && (
        <div className='mx-4 mb-5'>
          <div className='has-text-centered mb-5 has-text-info'>
            <p className='is-size-5 has-text-semibold'>
              Link Reset Password Terkirim
            </p>
          </div>
          <p className='is-italic has-text-centered is-size-6 notification is-info is-light'>
            Email telah dikirim. Cek email untuk melakukan reset password.
          </p>
        </div>
      )}
      {!status && (
        <div>
          <div className='has-text-centered mb-5 has-text-info'>
            <p className='is-size-6'>Apakah Anda lupa password?</p>
            <p className='has-text-info is-size-7 is-italic'>
              Isikan email untuk mendapatkan link reset password:
            </p>
          </div>
          <form
            onSubmit={handleSubmit(handleForgetPassword)}
            autoComplete='off'
          >
            <div className='mx-4'>
              <Field
                name='email'
                type='text'
                autoComplete='new-password'
                component={LoginTextInput}
                placeholder='Email'
                label='Email'
                icon='email'
              />
              {message === 'Email is not registered!' && (
                <p
                  className='has-text-danger is-size-7'
                  style={{ marginTop: -10 }}
                >
                  Email tidak terdaftar.
                </p>
              )}
            </div>
            <div className='mx-4 my-4'>
              <p className='is-italic is-size-7 notification is-info is-light'>
                Note: Reset password via email dapat dilakukan jika email telah
                didaftarkan sebelumnya, saat user login ke dalam portal sekolah.
              </p>
            </div>
            <div className='field has-text-centered' style={{ marginTop: 25 }}>
              {error && <p className='help is-danger'>{error}</p>}
              <button
                type='submit'
                disabled={loading}
                style={{ marginRight: 10 }}
                className={`button is-info is-small is-rounded${
                  loading ? ' is-loading' : ''
                }`}
              >
                Get Link
              </button>
            </div>
          </form>
        </div>
      )}
      <BackToLogin inBackToLogin={handleBackToLogin} />
    </BodyAuth>
  );
}

export default withRouter(
  connect(
    mapState,
    actions
  )(reduxForm({ form: 'formForgetPassword', validate })(ForgetPassword))
);
